import { useEventGroup } from "Hooks/Endpoints";
import React, { useEffect } from "react";
import SequenceDiagram from "react-sequence-diagram";
import { Button } from "semantic-ui-react";

const EventSequence = () => {
  const { getSequence, getPCAP, sequence, event, pcap } = useEventGroup();

  useEffect(() => {
    if (event) {
      getPCAP();
      getSequence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  const downloadPCAP = () => {
    if (pcap) {
      var blob = new Blob([pcap], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${event.id}.pcap`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link?.parentNode?.removeChild(link);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "80vh",
        overflow: "auto",
        textAlign: "center",
        borderBottom: "thin solid #ccc",
      }}
    >
      {sequence && (
        <SequenceDiagram
          input={sequence}
          options={{ theme: "simple" }}
          onError={(e: any) => console.log(e)}
        />
      )}
      <Button primary onClick={downloadPCAP}>
        Download PCAP
      </Button>
    </div>
  );
};

export default EventSequence;
